import * as React from 'react';
import { UIComponentViewImpl } from '../../../../toolkit/uicomponentview';
import { UIDataModel, UIComponentHandler} from '../../../../toolkit/uicomponent';
import { CallerSettingsComponentProps, CallerSettingsComponentState, CallerSettingsComponentHandler } from './callersettingscomponent';
import { CallerSettingsCSSStyle } from './callersettingscss';
import { CheckboxWithTextComponent } from '../../../../toolkit/checkboxwithtext/checkboxwithtextcomponent';
import { CheckboxWithTextCSSStyleImpl } from '../../../../toolkit/checkboxwithtext/checkboxwithtextcss';
import { Strings } from '../../../../../utils/resources/strings';
import { MsisdnTextComponent } from '../../../../toolkit/text/msisdntext/msisdntextcomponent';
import { DropdownRowViewModelHandler, DropDownRowViewModelImpl } from '../../../../toolkit/dropdownlist/dropdownrow/dropdownviewmodel';
import { BaseContext } from '../../../../../utils/basecontext';
import { DropDownDto, DropDownDtoImpl } from '../../../../../core/dto/dropdown/dropdowndto';
import { SelectComponent } from '../../../../toolkit/select/selectcomponent';
import { TimeBasedSettingForSpecificCallerDtoImpl } from '../../../../../core/dto/timebasedsetting/timebasedsettingforspecificcallerdto';
import { TimeBasedSettingForCallersGroupDtoImpl } from '../../../../../core/dto/timebasedsetting/timebasedsettingforcallersgroupdto';
import { GroupDto } from '../../../../../core/dto/listtones/groupdto';
import { MSISDNValidation } from '../../../../toolkit/msisdnvalidation/msisdnvalidation';
import { SpecialCallerTextComponent } from '../../../../toolkit/text/msisdntext/specialcallertextcomponent';
import './caller-settings-style.css';
import { LanguageConst } from 'src/com/sixdee/crbtportal/utils/resources/languageconst';

export class CallerSettingsViewImpl extends UIComponentViewImpl<UIDataModel> implements DropdownRowViewModelHandler
{
    private listViewModel: DropDownRowViewModelImpl;
    private selectGroupComponent: SelectComponent | null;
    private specialCallerRef: MsisdnTextComponent | null;

    constructor(context: BaseContext, handler: UIComponentHandler)
    {
        super(context, handler);
        
       this.listViewModel = new DropDownRowViewModelImpl(false, context, this);
    //    this.listViewModel.setListDatas(this.getListOfDropDown());
    }





    bindHandlers()
    {
        this.onSelected = this.onSelected.bind(this);
        this.onRowSelected = this.onRowSelected.bind(this);
        this.getAddToShuffle = this.getAddToShuffle.bind(this);
    }
    
    draw(props: CallerSettingsComponentProps, state: CallerSettingsComponentState, cssStyle: CallerSettingsCSSStyle): JSX.Element | boolean
    {
        super.draw(props, state, cssStyle);

        return (
            <>
            {
                this.getWebView(props, state, cssStyle)
            }
            </>
        );
    }

    getWebView(props: CallerSettingsComponentProps, state: CallerSettingsComponentState, cssStyle: CallerSettingsCSSStyle)
    {
        console.log("----props.isShuffleOn: " + props.isShuffleOn);
        return (
            <>
            <div id="caller-settings-main" style={cssStyle.getWrapperCSSStyle()}>
                <div id="caller-settings-allcaller"  style={{flex:"1", marginTop: "15px"}}>
                <CheckboxWithTextComponent onChange={this.onSelected} isChecked={state.callerSetting === props.context.getResources().getString(Strings.all_callers)} style={new CheckboxWithTextCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.all_callers)} context={props.context}/>
                </div>
                {/* <div style={{flex:"1", marginTop: "15px"}}>
                <CheckboxWithTextComponent onChange={this.onSelected} isChecked={state.callerSetting === props.context.getResources().getString(Strings.callers_group)} style={new CheckboxWithTextCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.callers_group)} context={props.context}/>
                </div> */}
                <div id="caller-settings-specialcaller"  style={{flex:"1", marginTop: "15px"}}>
                <CheckboxWithTextComponent onChange={this.onSelected} isChecked={state.callerSetting === props.context.getResources().getString(Strings.special_caller)} style={new CheckboxWithTextCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.special_caller)} context={props.context}/>
                </div>
                {
                    props.isShuffleOn === true &&
                    <div id="caller-settings-specialcaller"  style={{flex:"1", marginTop: "15px"}}>
                        <CheckboxWithTextComponent onChange={this.onSelected} isChecked={state.callerSetting === props.context.getResources().getString(Strings.add_to_shuffle)} style={new CheckboxWithTextCSSStyleImpl(props.context)} title={props.context.getResources().getString(Strings.add_to_shuffle)} context={props.context}/>
                </div>
                }
                
            </div>
            
                {
                    state.callerSetting === props.context.getResources().getString(Strings.all_callers) && <></>}
            
                {
                    state.callerSetting === props.context.getResources().getString(Strings.callers_group) && this.getCallerGroupCSS()
                }
           
                {
                    state.callerSetting === props.context.getResources().getString(Strings.special_caller) && this.getSpecialCallerCSS()
                }
                 {/* {
                    state.callerSetting === props.context.getResources().getString(Strings.add_to_shuffle) && this.getAddToShuffle(state.callerSetting,props)}
             */}
                </>
        );
    }

    validate():boolean
    {
        let timeSelectingSelected = (this.getUIState() as CallerSettingsComponentState).callerSetting;
        if(timeSelectingSelected === this.getUIProps().context.getResources().getString(Strings.callers_group))
        {
            if(this.selectGroupComponent !== null && this.selectGroupComponent.validate())
            {
               return true;
            }            
            else
            {
                return false;
            }
        }
        else if(timeSelectingSelected === this.getUIProps().context.getResources().getString(Strings.special_caller))
        {
            if(this.specialCallerRef !== null && this.specialCallerRef.validate())
            {
                let msisdn = MSISDNValidation.validateCCMsisdn(
                    this.getUIProps().context.getResources().getString(Strings.countrycode), this.specialCallerRef.getData());
                
                let numberMinLength = this.getUIProps().context.getResources().getString(Strings.numberMinLength);
                let numbermaxLength = this.getUIProps().context.getResources().getString(Strings.numberMaxLength);
                if(!MSISDNValidation.validateLengthMsisdn(msisdn, numberMinLength, numbermaxLength))
                {
                    this.specialCallerRef.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                    return false;
                }
                else if(this.getContext().getUserContext().getMsisdn() === this.specialCallerRef.getData())
                {
                    this.specialCallerRef.setErrorMessage(this.getContext().getResources().getString(Strings.number_cannot_be_same_as_the_logged_in_number));
                    return false;
                }
                
                return true;   
            } 
            return false;    
                // if(this.specialCallerRef.getData().length < numberMinLength 
                //                 || this.specialCallerRef.getData().length > numbermaxLength)
                // {
                //     this.specialCallerRef.setErrorMessage(this.getUIProps().context.getResources().getString(Strings.invalidLength));
                //     return false;
                // }
                
                // return true;   
            }     
        return true;
    }

    getSpecialCallerData(timeBasedSettingForSpecificCallerDto: TimeBasedSettingForSpecificCallerDtoImpl)
    {
        if(this.specialCallerRef !== null)
        {
            timeBasedSettingForSpecificCallerDto.setBPartyMsisdn(this.specialCallerRef.getData());
        }
    }

    getAddToShuffle(type:string, props:CallerSettingsComponentProps)
    {
        console.log("getAddToShuffle() invoked", type +"",type === this.getContext().getResources().getString(Strings.add_to_shuffle));
        if(type === this.getContext().getResources().getString(Strings.add_to_shuffle))
        {
            props.onAddToShuffleSelected(true);
        }
        else
        {
            props.onAddToShuffleSelected(false);

        }
    }
    getCallerGroupData(timeBasedSettingForCallersGroupDto: TimeBasedSettingForCallersGroupDtoImpl)
    {
        if(this.selectGroupComponent !== null)
        {
            let groupId = this.selectGroupComponent.getId();

            timeBasedSettingForCallersGroupDto.setGroupId(groupId);
            timeBasedSettingForCallersGroupDto.setGroupName(this.selectGroupComponent.getData());

            let groupDto = (this.getUIState() as CallerSettingsComponentState).groupsList.find((groupData: GroupDto) =>
            {
                return groupId === groupData.getGroupId();
            });

            timeBasedSettingForCallersGroupDto.setGroupDesc(groupDto !== undefined ? groupDto.getGroupDesc() : "");
        }
    }

    onRowSelected(dropDownDto: DropDownDto): void 
    {
       this.selectGroupComponent !== null
        && this.selectGroupComponent.onOptionSelected(dropDownDto.getId(), dropDownDto.getTitle());
    }

    private getCallerGroupCSS()
    {
        this.listViewModel.setListDatas(this.getListOfDropDown());
        return (
        <div style={{paddingLeft: "0px", paddingRight: "30px", paddingTop: "20px", display: "flex", flexFlow: "row wrap"}}>
            <div style={{width: "304px"}}>
                <SelectComponent listEmptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.no_groups_avaliable)}ref={(item)=>{this.selectGroupComponent = item;}} listViewModel={this.listViewModel} placeholder={this.getUIProps().context.getResources().getString(Strings.select_group)} id={"#selectgroup"} value={""} isRequired={true}  context={this.getUIProps().context} emptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.invalid_group)}/>
            </div>
            {/* <div style={{paddingTop: "29px", width: "180px", paddingLeft: "30px", paddingRight:"30px"}}>
                <ButtonComponent onClick={()=>{}} style={new ButtonCSSStyleImpl(this.getUIProps().context)} context={this.getUIProps().context} label={this.getUIProps().context.getResources().getString(Strings.add_new_group)}/>
            </div> */}
        </div>);
    }

    private getSpecialCallerCSS()
    {
        return (
            <div style={{width: "304px", paddingLeft: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "0px" : "0px", paddingRight: this.getContext().getUserContext().getLanguage() === LanguageConst.FRENCH ? "30px" : "30px", paddingTop: "20px"}}>
                <SpecialCallerTextComponent hint={this.getContext().getResources().getString(Strings.mobilenumberhint)} maxLength={this.getContext().getResources().getString(Strings.numberMaxLength)} label={this.getContext().getResources().getString(Strings.add_number)} ref={(item: any)=>{this.specialCallerRef = item;}} placeholder={this.getContext().getResources().getString(Strings.add_number)}  isDisabled={false} id={"#mobilenumber"} value={""} inputType={"number"} isRequired={false}  context={this.getUIProps().context} emptyErrorMsg={this.getUIProps().context.getResources().getString(Strings.numberIncorrect)}/> 
            </div>);
    }

    private onSelected(isSelected: boolean, callerSetting: string)
    {
        (this.getUIComponentHandler() as CallerSettingsComponentHandler).onCallerSettingSelected(callerSetting);
    }

    private getListOfDropDown()
    {  
        return (this.getUIState() as CallerSettingsComponentState).groupsList.map((groupDto: GroupDto) =>
        {
            let dropDown1 = new DropDownDtoImpl();
            dropDown1.setId(groupDto.getGroupId());
            dropDown1.setIconName("");
            dropDown1.setTitle(groupDto.getGroupName());

            return dropDown1;
        });
    //     let dropDown1 = new DropDownDtoImpl();
    //     dropDown1.setId(RoutingFeatures.PROFILE);
    //     dropDown1.setIconName("");
    //     dropDown1.setTitle(this.getContext().getResources().getString(Strings.myprofile));
       
    //     let dropDown2 = new DropDownDtoImpl();
    //     dropDown2.setId(RoutingFeatures.TRANSACTION_HISTORY);
    //     dropDown2.setIconName("");
    //     dropDown2.setTitle(this.getContext().getResources().getString(Strings.history));

    //     let dropDown3 = new DropDownDtoImpl();
    //     dropDown3.setId(RoutingFeatures.WISHLIST);
    //     dropDown3.setIconName("");
    //     dropDown3.setTitle(this.getContext().getResources().getString(Strings.wishlist));

    //     let dropDown4 = new DropDownDtoImpl();
    //     dropDown4.setId(RoutingFeatures.MYTUNES);
    //     dropDown4.setIconName("");
    //     dropDown4.setTitle(this.getContext().getResources().getString(Strings.mytunes));

    //    let dropDown5 = new DropDownDtoImpl();
    //    dropDown5.setId(RoutingFeatures.LOGOUT);
    //    dropDown5.setIconName("");
    //    dropDown5.setTitle(this.getContext().getResources().getString(Strings.logout));

    //     return [dropDown1, dropDown2, dropDown3, dropDown4, dropDown5];
    }
}




// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/tunesettings/callersettings/callersettingsview.tsx